import { formatNumber } from '@angular/common';

export const formatMoneyInList = (e: number) => formatNumber(e, 'en-US', '1.2-2');
export const formatMoneyInForm = (e: number) => formatNumber(e, 'en-US', '1.2-2').replace(/,/g, '');

